import { mapState } from 'vuex';
import ApiService from '@/services/apiService';
import { themesMixin } from '@/utils/themes';
import WGS84Service from '@/services/wgs84ProjectionService';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
import set from 'lodash/set';
import mixinActionBoxStyles from '@/components/core/mixinActionBoxStyles';
export default {
  name: 'ViewNiotaClassicGatewayManagementGWDetails',
  mixins: [themesMixin, mixinActionBoxStyles],
  data: function () {
    return {
      plainAccounts: [],
      formDialog: false,
      gatewayData: {},
      showHeaderMap: false,
      pageYOffset: 0,
      tabItem: 'details',
      loading: true
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions']),
    headerBG() {
      return './img/gwmgmt.png';
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isIotHubManager() {
      return this.permissions['IotHub.manage'];
    },
    gatewayId() {
      return this.$route.params.gatewayId;
    },
    gatewayCoordinates() {
      return get(this.gatewayData, 'coordinates.coordinates', [null, null]);
    },
    gatewayPolygon() {
      return get(this.gatewayData, 'polygon.coordinates', []);
    },
    showMap() {
      if (!this.loading && get(this.gatewayData, 'coordinates.coordinates[1]')) {
        return this.hasValidCoordinate;
      }
      return false;
    },
    hasValidCoordinate() {
      const coordinate = {
        lat: this.gatewayCoordinates[1],
        lon: this.gatewayCoordinates[0]
      };
      return WGS84Service.isValidWgs84(coordinate);
    }
  },
  watch: {
    $route() {
      this.loading = true;
      this.gatewayData = {};
      this.loadGatewayDetails();
    }
  },
  mounted() {
    this.loadGatewayDetails();
    this.getPlainAccounts();
  },
  methods: {
    getPlainAccounts() {
      this.$store.dispatch('app/loadAccounts').then(accounts => {
        this.accounts = accounts;
      }).catch(error => {
        console.error(error);
      });
    },
    breadCrumbsPath() {
      if (get(this.gatewayData, 'account.name')) {
        return [this.permissions['all.manage'] ? {
          text: this.gatewayData.account.name,
          to: `/account-mgmt/${this.gatewayData.account.id}`
        } : this.gatewayData.account.name, this.gatewayData.title];
      }
      return [];
    },
    loadGatewayDetails() {
      ApiService.gwMgmtGetDetails(this.gatewayId).then(gatewayData => {
        this.gatewayData = gatewayData;
        set(this.gatewayData, 'address.formatted_address', get(this.gatewayData, 'properties.formatted_address'));
      }).catch(error => {
        this.gatewayData = {};
        this.$snack(this.$i18n_t('NiotaClassic.GWMonitoring.snacks.fetchDetailsFailed'), 'error');
        console.error(error);
      }).finally(() => {
        this.loading = false;
      });
    },
    updateDetails(item) {
      this.gatewayData = cloneDeep(item);
    },
    viewAllDevices() {
      this.$router.push({
        path: '/niota-classic/gw-mgmt'
      });
    },
    saveScrollOffset() {
      this.pageYOffset = window.pageYOffset;
    }
  }
};